import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
import { OptionContent } from "../../../DropdownList/components/OptionContent";
import { checkLabel } from "../../utils/checkLabel";
var cn = classNames.bind(style);
export var SelectToggle = /*#__PURE__*/memo(function (_ref) {
  var _cn;
  var onClick = _ref.onClick,
    isOpen = _ref.isOpen,
    option = _ref.option,
    isError = _ref.isError,
    disabled = _ref.disabled,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'main' : _ref$theme,
    title = _ref.title,
    emptyValueText = _ref.emptyValueText,
    icon = _ref.icon,
    buttonRef = _ref.buttonRef,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur;
  var isElemArray = function isElemArray(src) {
    return Array.isArray(src) === true;
  };
  var labelText = checkLabel({
    option: option,
    icon: icon,
    title: title,
    emptyValueText: emptyValueText
  });
  return /*#__PURE__*/React.createElement("button", {
    className: cn('toggle', (_cn = {
      'toggle--opened': isOpen,
      'toggle--error': isError
    }, _defineProperty(_cn, "toggle--".concat(theme), theme), _defineProperty(_cn, 'toggle--empty', labelText === emptyValueText && theme !== 'secondary'), _cn)),
    disabled: disabled,
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    ref: buttonRef,
    type: "button",
    "data-t-id": "components-SelectToggle"
  }, /*#__PURE__*/React.createElement(OptionContent, {
    activeOptions: option,
    additionalInfo: isElemArray(option) ? undefined : option === null || option === void 0 ? void 0 : option.additionalInfo,
    cardNumber: isElemArray(option) ? undefined : option === null || option === void 0 ? void 0 : option.cardNumber,
    disabled: disabled,
    icon: icon,
    iconSrc: isElemArray(option) ? undefined : option === null || option === void 0 ? void 0 : option.iconSrc,
    isToggle: true,
    label: labelText,
    theme: theme,
    toggleConfig: {
      isOpen: isOpen,
      theme: theme
    }
  }));
});